import './publication.scss';

function init() {
    console.log("publication.js");
}

export default init;

export function publication(block) {
    // console.log("HELLO publication adobe pdf", block);
    var group = block.closest('.wp-block-group');

    if (group) {
        if (group.classList.contains("group--publication")) {
            console.log("Publication block is inside a group");

            function processAdobeBlock(adobeBlock) {
            
                if (adobeBlock) {
                    console.log("Found Adobe PDF Embed block", adobeBlock);

                    let blockAttributes = window.wp.data.select('core/block-editor').getBlock(adobeBlock.dataset.block);

                    if (blockAttributes && blockAttributes.attributes) {
                        const embedMode = blockAttributes.attributes.embedMode || 'UNKNOWN_MODE';
                        console.log("Embed Mode:", embedMode);

                        adobeBlock.setAttribute('data-embed-mode', embedMode);
                        group.setAttribute('data-embed-mode', embedMode);

                        const acfField = group.querySelector('div.acf-field[data-name="pdf_embed_type"]');
                        if (acfField) {
                            const hiddenField = acfField.querySelector('input[type="text"]');
                            if (hiddenField) {
                                hiddenField.value = embedMode;
                                console.log("ACF field updated with embed mode:", embedMode);
                                hiddenField.setAttribute('value', embedMode);

                                // value="IN_LINE, LIGHT_BOX, FULL_WINDOW, EMBEDDED_VIEWER, UNKNOWN_MODE"

                            } else {
                                console.error("Text input inside ACF container not found");
                            }
                        } else {
                            console.error("ACF field container with data-name 'pdf_embed_type' not found");
                        }
                    } else {
                        console.error("Could not find block attributes");
                    }
                } else {
                    console.error("No Adobe PDF Embed block found in the group");
                }

            }

            var adobeBlock = group.querySelector('[data-type="pdf-embed-plugin-for-wp/embedded-pdf"]');
            if (adobeBlock) {
                processAdobeBlock(adobeBlock);
            } else {
                console.error("Adobe PDF Embed block not found at initial check.");
            }

            // Optimized observer
            const observer = new MutationObserver(mutations => {
                let adobeBlockDetected = false;
                mutations.forEach(mutation => {
                    if (mutation.type === 'childList' || mutation.type === 'attributes') {
                        const updatedAdobeBlock = group.querySelector('[data-type="pdf-embed-plugin-for-wp/embedded-pdf"]');
                        if (updatedAdobeBlock) {
                            adobeBlockDetected = true;
                            processAdobeBlock(updatedAdobeBlock);
                        }
                    }
                });

                if (!adobeBlockDetected) {
                    console.error("Adobe PDF Embed block not found during MutationObserver callback.");
                }
            });

            // Start observing the group for changes
            observer.observe(group, { childList: true, subtree: true, attributes: false });

            // Clean up observer if necessary (e.g., when block is removed)
            return () => {
                observer.disconnect();
            };
        }
    } else {
        console.log("Publication block is not inside a group - review but don't need to do anything");
    }
}
